<template>
	<router-view></router-view>
</template>
<script>
export default {
	name: 'registro-preco',
}
</script>
